export default "__VITE_ASSET__1c124ae8__"